import React from "react";
import { colors } from "../../../../../themes/Colors";
import BaseButtons from "../../../base-buttons/BaseButtons";

const PrivateInfoPopCheck = ({ display, onCloseClick }) => {
  return (
    <div
      style={{
        height: display ? "100%" : 0,
        width: "100%",
        backgroundColor: colors.white,
        position: "fixed",
        bottom: 0,
        zIndex: 100,
        transition: "all 0.3s",
        opacity: display ? 1 : 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          flex: 1,

          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flexDirection: "column",
          overflowY: "scroll",
        }}
      >
        <div style={{ paddingTop: 90 }} />
        <div style={{ width: "80%", textAlign: "center", marginBottom: 20 }}>
          You have not uploaded your Private information i.e ID DOCUMENT
        </div>

        <div style={{ width: "80%", textAlign: "center", marginBottom: 60 }}>
          Dont worry when you close this we will take you to the right place
        </div>
        <BaseButtons
          label={"CLOSE"}
          onClick={onCloseClick}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          width={"80%"}
        />
      </div>
    </div>
  );
};

export default PrivateInfoPopCheck;
